import React, { useRef, useState } from "react";
import { FormatAlignCenter, FormatAlignJustify, FormatAlignLeft, FormatAlignRight } from "@mui/icons-material";
import Menu from "@mui/material/Menu";
import { MenuItem, ToggleButton } from "@mui/material";
import { useCurrentEditor } from "@tiptap/react";

export default function TextAlign() {
  const menuAnchor = useRef<HTMLButtonElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  const handleTextAlignChange = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, textAlign: string) => {
    editor.chain().focus().setTextAlign(textAlign).run();
    setMenuOpen(false);
    event.stopPropagation();
  };

  return (
    <ToggleButton
      value={""}
      selected={menuOpen}
      onChange={() => {
        setMenuOpen((prevState) => !prevState);
      }}
      ref={menuAnchor}
    >
      <FormatAlignLeft />
      <Menu
        open={menuOpen}
        onClose={(event: React.SyntheticEvent) => {
          setMenuOpen(false);
          event.stopPropagation();
        }}
        anchorEl={menuAnchor.current}
      >
        <MenuItem onClick={(event) => handleTextAlignChange(event, "left")}>
          <FormatAlignLeft />
        </MenuItem>
        <MenuItem onClick={(event) => handleTextAlignChange(event, "center")}>
          <FormatAlignCenter />
        </MenuItem>
        <MenuItem onClick={(event) => handleTextAlignChange(event, "right")}>
          <FormatAlignRight />
        </MenuItem>
        <MenuItem onClick={(event) => handleTextAlignChange(event, "justify")}>
          <FormatAlignJustify />
        </MenuItem>
      </Menu>
    </ToggleButton>
  );
}
